import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  gap: 1rem;
  flex-direction: column;

  .page-title {
    display: flex;
    padding: 1rem 1.5rem;
    justify-content: start;
  }
`;

export const Body = styled.div`
  background: ${({ theme }) => theme.colors.background};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .divAlert {
    display: flex;
    align-items: center;
    margin: 1rem auto;
    max-width: 640px;
    border-radius: 8px;

    .containerMessage {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      font-size: 0.95rem;
      line-height: 1.5;

      h1 {
        font-size: 1rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.error};
      }
    }

    .MuiAlert-root {
      border-radius: 1rem;
      border: 2px solid #a50808;
      vertical-align: middle;
    }

    .MuiAlert-message {
      color: #a50808;
      font-size: 1.1rem;
      margin-bottom: 0.1rem;
    }

    .MuiAlert-icon {
      padding: 0.5rem;
      margin: 0;
      color: #a50808;
    }

    .forgetPassword {
      color: #a50808;
      font-size: 1.1rem;
      font-weight: bold;
      padding-left: 0.5rem;
    }

    @media (max-width: 1000px) {
      width: 70%;
    }

    @media (max-width: 300px) {
      width: 95%;
    }
  }

  .divNone {
    display: none;
  }
`;

export const Form = styled.form`
  display: flex;
  width: 30%;
  margin: auto;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.colors.background_white};
  border-radius: 13px;
  padding: 2rem 3rem;

  .formDiv {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background: ${({ theme }) => theme.colors.background_white};
    border-radius: 13px;

    .divRecaptcha {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    @media (min-width: 280px) and (max-width: 355px) {
      .divRecaptcha div {
        width: -webkit-fill-available;
        display: flex;
        justify-content: center;
        transform: scale(0.94);
      }
    }
  }

  @media (max-width: 1000px) {
    width: 60%;
  }

  @media (max-width: 300px) {
    width: 75%;
    padding: 1.5rem 2rem;
  }

  .buttonDiv {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 0.75rem auto;

    @media (max-width: 660px) {
      justify-content: center;
    }
  }

  .forgetDiv {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1rem;
    width: 100%;
    margin: 0.5rem auto;

    .forgetPassword {
      color: ${({ theme }) => theme.colors.secondary};
      text-align: right;
      text-decoration: underline;
      font-size: 14px;
      font-weight: 450;
    }

    a {
      color: ${({ theme }) => theme.colors.primary};
    }

    @media (max-width: 660px) {
      align-items: center;

      .forgetPassword {
        text-align: center;
      }
    }
  }
`;
